<template>
  <dl class="my-10 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
    <slot></slot>
  </dl>
</template>

<script>
export default {}
</script>
